"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Text = _interopRequireDefault(require("../../../components/Text"));
var Theme = _interopRequireWildcard(require("../../../theme"));
var _system = require("@mui/system");
var _i18n = _interopRequireDefault(require("../../../localization/i18n"));
var _tokens = _interopRequireDefault(require("../../../localization/tokens"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/* eslint-disable no-shadow */
/* eslint-disable require-jsdoc */

/**
 * 
 * @param {*} param0 
 * @returns 
 */
var RateTable = function RateTable(_ref) {
  var _pricing$lifeInsuranc, _pricing$deathDismemb, _pricing$dependentLif, _pricing$ltd$family$p, _pricing$std$family$p, _pricing$criticalIlln, _pricing$criticalIlln2, _pricing$criticalIlln3, _pricing$criticalIlln4, _pricing$criticalIlln5, _pricing$criticalIlln6, _pricing$criticalIlln7, _pricing$criticalIlln8, _pricing$criticalIlln9, _pricing$outOfProvinc, _pricing$outOfProvinc2, _pricing$outOfProvinc3, _pricing$stopLoss$sol, _pricing$stopLoss$duo, _pricing$stopLoss$fam, _pricing$virtualHealt, _pricing$virtualHealt2, _pricing$virtualHealt3, _pricing$financialAwa, _pricing$financialAwa2, _pricing$financialAwa3;
  var pricing = _ref.pricing,
    isAsoDental = _ref.isAsoDental,
    isAsoHealth = _ref.isAsoHealth;
  var theme = (0, _system.useTheme)();
  var styles = {
    pricingContainer: {
      maxWidth: 1000,
      marginLeft: 'auto',
      marginRight: 'auto'
    },
    block: {
      display: 'flex',
      flex: 1,
      flexDirection: 'column'
    },
    headerBar: {
      display: 'flex',
      flex: 1,
      flexDirection: 'row',
      marginTop: 20,
      marginBottom: 10,
      padding: 8,
      backgroundColor: theme.palette.primary.main
    },
    row: {
      display: 'flex',
      flex: 1,
      flexDirection: 'row',
      padding: "5px 30px 0 50px"
    },
    rowCondensed: {
      display: 'flex',
      flex: 1,
      flexDirection: 'row',
      padding: 8
    },
    line: {
      width: '98%',
      height: 2,
      opacity: 0.5,
      backgroundColor: theme.palette.primary.main,
      margin: "10px auto"
    },
    amountBlock: {
      display: 'flex',
      flex: 1,
      flexDirection: 'column',
      alignItems: 'center'
    }
  };
  var _numberWithCommas = function _numberWithCommas(number) {
    var noDollar = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    if (!number) {
      return 0;
    }
    if (noDollar) {
      return "".concat(number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','));
    }
    return "$".concat(number.toFixed(3).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','));
  };
  var _getHealthGrossRate = function _getHealthGrossRate(pricing, coverageType) {
    coverageType = coverageType.toLowerCase();
    return pricing.drugs[coverageType].grossRate + pricing.majorMedical[coverageType].grossRate + pricing.paramedicals[coverageType].grossRate + pricing.eyeExams[coverageType].grossRate + pricing.eyeGlassesAndContacts[coverageType].grossRate + pricing.requiredMedicalEyewear[coverageType].grossRate;
  };
  var _getHealthNetRate = function _getHealthNetRate(pricing, coverageType) {
    coverageType = coverageType.toLowerCase();
    return pricing.drugs[coverageType].netRate + pricing.majorMedical[coverageType].netRate + pricing.paramedicals[coverageType].netRate + pricing.eyeExams[coverageType].netRate + pricing.eyeGlassesAndContacts[coverageType].netRate + pricing.requiredMedicalEyewear[coverageType].netRate;
  };
  var _getHealthPastRate = function _getHealthPastRate(pricing, coverageType) {
    coverageType = coverageType.toLowerCase();
    if (!pricing.drugs[coverageType].pastRates) {
      return 0;
    }
    return pricing.drugs[coverageType].pastRates.grossRate + pricing.majorMedical[coverageType].pastRates.grossRate + pricing.paramedicals[coverageType].pastRates.grossRate + pricing.eyeExams[coverageType].pastRates.grossRate + pricing.eyeGlassesAndContacts[coverageType].pastRates.grossRate + pricing.requiredMedicalEyewear[coverageType].pastRates.grossRate;
  };
  var _getDentalGrossRate = function _getDentalGrossRate(pricing, coverageType) {
    coverageType = coverageType.toLowerCase();
    return pricing.basicDental[coverageType].grossRate + pricing.majorDental[coverageType].grossRate + pricing.orthodontics[coverageType].grossRate;
  };
  var _getDentalNetRate = function _getDentalNetRate(pricing, coverageType) {
    coverageType = coverageType.toLowerCase();
    return pricing.basicDental[coverageType].netRate + pricing.majorDental[coverageType].netRate + pricing.orthodontics[coverageType].netRate;
  };
  var _getDentalPastRate = function _getDentalPastRate(pricing, coverageType) {
    coverageType = coverageType.toLowerCase();
    if (!pricing.basicDental[coverageType].pastRates) {
      return 0;
    }
    return pricing.basicDental[coverageType].pastRates.grossRate + pricing.majorDental[coverageType].pastRates.grossRate + pricing.orthodontics[coverageType].pastRates.grossRate;
  };
  var _getEfapGrossRate = function _getEfapGrossRate(pricing, coverageType) {
    coverageType = coverageType.toLowerCase();
    return pricing.employeeAssistance[coverageType].grossRate + pricing.medicalSecondOpinion[coverageType].grossRate + pricing.eldercare[coverageType].grossRate;
  };
  var _getEfapPastRate = function _getEfapPastRate(pricing, coverageType) {
    coverageType = coverageType.toLowerCase();
    if (!pricing.employeeAssistance[coverageType].pastRates) {
      return 0;
    }
    return pricing.employeeAssistance[coverageType].pastRates.grossRate + pricing.medicalSecondOpinion[coverageType].pastRates.grossRate + pricing.eldercare[coverageType].pastRates.grossRate;
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.pricingContainer
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.block
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      flex: 1,
      justifyContent: 'space-between',
      alignItems: 'center'
    }
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    largest: true,
    bold: true
  }, _i18n["default"].t(_tokens["default"].labels.advisor.rateSummary)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    color: Theme.colors.mediumGrey
  }, _i18n["default"].t(_tokens["default"].labels.advisor.previousRates))), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.headerBar
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true,
    color: Theme.colors.surface,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _i18n["default"].t(_tokens["default"].labels.coverage.benefit)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true,
    color: Theme.colors.surface,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _i18n["default"].t(_tokens["default"].labels.advisor.rate)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true,
    color: Theme.colors.surface,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _i18n["default"].t(_tokens["default"].titles.carrier))), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.rowCondensed
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1
    }
  }, "\xA0", _i18n["default"].t(_tokens["default"].titles.lifeInsurance)), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.amountBlock
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _numberWithCommas(pricing.lifeInsurance.family.grossRate)), ((_pricing$lifeInsuranc = pricing.lifeInsurance.family.pastRates) === null || _pricing$lifeInsuranc === void 0 ? void 0 : _pricing$lifeInsuranc.grossRate) > 0 && /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    },
    color: Theme.colors.mediumGrey
  }, _numberWithCommas(pricing.lifeInsurance.family.pastRates.grossRate))), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, pricing.lifeInsurance.carrier || 'N/A')), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.rowCondensed
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1
    }
  }, "\xA0", _i18n["default"].t(_tokens["default"].titles.accidentalDeathAndDismemberment)), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.amountBlock
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _numberWithCommas(pricing.deathDismemberment.family.grossRate)), ((_pricing$deathDismemb = pricing.deathDismemberment.family.pastRates) === null || _pricing$deathDismemb === void 0 ? void 0 : _pricing$deathDismemb.grossRate) > 0 && /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    },
    color: Theme.colors.mediumGrey
  }, _numberWithCommas(pricing.deathDismemberment.family.pastRates.grossRate))), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, pricing.deathDismemberment.carrier || 'N/A')), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.rowCondensed
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1
    }
  }, "\xA0", _i18n["default"].t(_tokens["default"].titles.dependentLife)), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.amountBlock
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _numberWithCommas(pricing.dependentLife.family.grossRate)), ((_pricing$dependentLif = pricing.dependentLife.family.pastRates) === null || _pricing$dependentLif === void 0 ? void 0 : _pricing$dependentLif.grossRate) > 0 && /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    },
    color: Theme.colors.mediumGrey
  }, _numberWithCommas(pricing.dependentLife.family.pastRates.grossRate))), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, pricing.dependentLife.carrier || 'N/A')), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.rowCondensed
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1
    }
  }, "\xA0", _i18n["default"].t(_tokens["default"].titles.longTermDisability)), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.amountBlock
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _numberWithCommas(pricing.ltd.family.grossRate)), ((_pricing$ltd$family$p = pricing.ltd.family.pastRates) === null || _pricing$ltd$family$p === void 0 ? void 0 : _pricing$ltd$family$p.grossRate) > 0 && /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    },
    color: Theme.colors.mediumGrey
  }, _numberWithCommas(pricing.ltd.family.pastRates.grossRate))), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, pricing.ltd.carrier || 'N/A')), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.rowCondensed
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1
    }
  }, "\xA0", _i18n["default"].t(_tokens["default"].titles.shortTermDisability)), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.amountBlock
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _numberWithCommas(pricing.std.family.grossRate)), ((_pricing$std$family$p = pricing.std.family.pastRates) === null || _pricing$std$family$p === void 0 ? void 0 : _pricing$std$family$p.grossRate) > 0 && /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    },
    color: Theme.colors.mediumGrey
  }, _numberWithCommas(pricing.std.family.pastRates.grossRate))), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, pricing.std.carrier || 'N/A')), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.rowCondensed
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1
    }
  }, "\xA0", _i18n["default"].t(_tokens["default"].titles.criticalIllness)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  })), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.rowCondensed
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1
    }
  }, "\xA0\xA0\xA0\xA0", _i18n["default"].t(_tokens["default"].labels.advisor.solo)), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.amountBlock
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _numberWithCommas(pricing.criticalIllness.solo.grossRate)), ((_pricing$criticalIlln = pricing.criticalIllness.solo.pastRates) === null || _pricing$criticalIlln === void 0 ? void 0 : _pricing$criticalIlln.grossRate) > 0 && /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    },
    color: Theme.colors.mediumGrey
  }, _numberWithCommas(pricing.criticalIllness.solo.pastRates.grossRate))), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, pricing.criticalIllness.carrier || 'N/A')), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.rowCondensed
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1
    }
  }, "\xA0\xA0\xA0\xA0", _i18n["default"].t(_tokens["default"].labels.advisor.duo)), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.amountBlock
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _numberWithCommas(pricing.criticalIllness.duo.grossRate)), ((_pricing$criticalIlln2 = pricing.criticalIllness.duo.pastRates) === null || _pricing$criticalIlln2 === void 0 ? void 0 : _pricing$criticalIlln2.grossRate) > 0 && /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    },
    color: Theme.colors.mediumGrey
  }, _numberWithCommas(pricing.criticalIllness.duo.pastRates.grossRate))), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, pricing.criticalIllness.carrier || 'N/A')), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.rowCondensed
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1
    }
  }, "\xA0\xA0\xA0\xA0", _i18n["default"].t(_tokens["default"].labels.advisor.family)), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.amountBlock
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _numberWithCommas(pricing.criticalIllness.family.grossRate)), ((_pricing$criticalIlln3 = pricing.criticalIllness.family.pastRates) === null || _pricing$criticalIlln3 === void 0 ? void 0 : _pricing$criticalIlln3.grossRate) > 0 && /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    },
    color: Theme.colors.mediumGrey
  }, _numberWithCommas(pricing.criticalIllness.family.pastRates.grossRate))), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, pricing.criticalIllness.carrier || 'N/A')), pricing.criticalIllnessSpouse.family.grossRate > 0 && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.rowCondensed
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1
    }
  }, "\xA0", _i18n["default"].t(_tokens["default"].titles.criticalIllnessSpouse)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  })), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.rowCondensed
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1
    }
  }, "\xA0\xA0\xA0\xA0", _i18n["default"].t(_tokens["default"].labels.advisor.solo)), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.amountBlock
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _numberWithCommas(pricing.criticalIllnessSpouse.solo.grossRate)), ((_pricing$criticalIlln4 = pricing.criticalIllnessSpouse.solo.pastRates) === null || _pricing$criticalIlln4 === void 0 ? void 0 : _pricing$criticalIlln4.grossRate) > 0 && /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    },
    color: Theme.colors.mediumGrey
  }, _numberWithCommas(pricing.criticalIllnessSpouse.solo.pastRates.grossRate))), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, pricing.criticalIllnessSpouse.carrier || 'N/A')), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.rowCondensed
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1
    }
  }, "\xA0\xA0\xA0\xA0", _i18n["default"].t(_tokens["default"].labels.advisor.duo)), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.amountBlock
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _numberWithCommas(pricing.criticalIllnessSpouse.duo.grossRate)), ((_pricing$criticalIlln5 = pricing.criticalIllnessSpouse.duo.pastRates) === null || _pricing$criticalIlln5 === void 0 ? void 0 : _pricing$criticalIlln5.grossRate) > 0 && /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    },
    color: Theme.colors.mediumGrey
  }, _numberWithCommas(pricing.criticalIllnessSpouse.duo.pastRates.grossRate))), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, pricing.criticalIllnessSpouse.carrier || 'N/A')), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.rowCondensed
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1
    }
  }, "\xA0\xA0\xA0\xA0", _i18n["default"].t(_tokens["default"].labels.advisor.family)), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.amountBlock
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _numberWithCommas(pricing.criticalIllnessSpouse.family.grossRate)), ((_pricing$criticalIlln6 = pricing.criticalIllnessSpouse.family.pastRates) === null || _pricing$criticalIlln6 === void 0 ? void 0 : _pricing$criticalIlln6.grossRate) > 0 && /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    },
    color: Theme.colors.mediumGrey
  }, _numberWithCommas(pricing.criticalIllnessSpouse.family.pastRates.grossRate))), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, pricing.criticalIllnessSpouse.carrier || 'N/A'))), pricing.criticalIllnessChild.family.grossRate > 0 && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.rowCondensed
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1
    }
  }, "\xA0", _i18n["default"].t(_tokens["default"].titles.criticalIllnessChild)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  })), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.rowCondensed
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1
    }
  }, "\xA0\xA0\xA0\xA0", _i18n["default"].t(_tokens["default"].labels.advisor.solo)), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.amountBlock
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _numberWithCommas(pricing.criticalIllnessChild.family.grossRate)), ((_pricing$criticalIlln7 = pricing.criticalIllnessChild.solo.pastRates) === null || _pricing$criticalIlln7 === void 0 ? void 0 : _pricing$criticalIlln7.grossRate) > 0 && /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    },
    color: Theme.colors.mediumGrey
  }, _numberWithCommas(pricing.criticalIllnessChild.solo.pastRates.grossRate))), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, pricing.criticalIllnessChild.carrier || 'N/A')), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.rowCondensed
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1
    }
  }, "\xA0\xA0\xA0\xA0", _i18n["default"].t(_tokens["default"].labels.advisor.duo)), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.amountBlock
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _numberWithCommas(pricing.criticalIllnessChild.duo.grossRate)), ((_pricing$criticalIlln8 = pricing.criticalIllnessChild.duo.pastRates) === null || _pricing$criticalIlln8 === void 0 ? void 0 : _pricing$criticalIlln8.grossRate) > 0 && /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    },
    color: Theme.colors.mediumGrey
  }, _numberWithCommas(pricing.criticalIllnessChild.duo.pastRates.grossRate))), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, pricing.criticalIllnessChild.carrier || 'N/A')), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.rowCondensed
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1
    }
  }, "\xA0\xA0\xA0\xA0", _i18n["default"].t(_tokens["default"].labels.advisor.family)), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.amountBlock
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _numberWithCommas(pricing.criticalIllnessChild.family.grossRate)), ((_pricing$criticalIlln9 = pricing.criticalIllnessChild.family.pastRates) === null || _pricing$criticalIlln9 === void 0 ? void 0 : _pricing$criticalIlln9.grossRate) > 0 && /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    },
    color: Theme.colors.mediumGrey
  }, _numberWithCommas(pricing.criticalIllnessChild.family.pastRates.grossRate))), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, pricing.criticalIllnessChild.carrier || 'N/A'))), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.rowCondensed
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1
    }
  }, "\xA0", _i18n["default"].t(_tokens["default"].labels.signup.extendedHealthCare)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  })), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.rowCondensed
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1
    }
  }, "\xA0\xA0\xA0\xA0", _i18n["default"].t(_tokens["default"].labels.advisor.solo)), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.amountBlock
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  },
  // Show net rate for ASO since we don't charge the gross rate for ASO
  isAsoHealth ? _numberWithCommas(_getHealthNetRate(pricing, 'solo')) : _numberWithCommas(_getHealthGrossRate(pricing, 'solo'))), _getHealthPastRate(pricing, 'solo') > 0 && /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    },
    color: Theme.colors.mediumGrey
  }, _numberWithCommas(_getHealthPastRate(pricing, 'solo')))), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, pricing.drugs.carrier || pricing.paramedicals.carrier || 'N/A')), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.rowCondensed
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1
    }
  }, "\xA0\xA0\xA0\xA0", _i18n["default"].t(_tokens["default"].labels.advisor.duo)), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.amountBlock
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  },
  // Show net rate for ASO since we don't charge the gross rate for ASO
  isAsoHealth ? _numberWithCommas(_getHealthNetRate(pricing, 'duo')) : _numberWithCommas(_getHealthGrossRate(pricing, 'duo'))), _getHealthPastRate(pricing, 'duo') > 0 && /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    },
    color: Theme.colors.mediumGrey
  }, _numberWithCommas(_getHealthPastRate(pricing, 'duo')))), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, pricing.drugs.carrier || pricing.paramedicals.carrier || 'N/A')), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.rowCondensed
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1
    }
  }, "\xA0\xA0\xA0\xA0", _i18n["default"].t(_tokens["default"].labels.advisor.family)), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.amountBlock
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  },
  // Show net rate for ASO since we don't charge the gross rate for ASO
  isAsoHealth ? _numberWithCommas(_getHealthNetRate(pricing, 'family')) : _numberWithCommas(_getHealthGrossRate(pricing, 'family'))), _getHealthPastRate(pricing, 'family') > 0 && /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    },
    color: Theme.colors.mediumGrey
  }, _numberWithCommas(_getHealthPastRate(pricing, 'family')))), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, pricing.drugs.carrier || pricing.paramedicals.carrier || 'N/A')), pricing.outOfProvince.family.grossRate > 0 && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.rowCondensed
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1
    }
  }, "\xA0", _i18n["default"].t(_tokens["default"].titles.outOfCountry)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  })), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.rowCondensed
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1
    }
  }, "\xA0\xA0\xA0\xA0", _i18n["default"].t(_tokens["default"].labels.advisor.solo)), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.amountBlock
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _numberWithCommas(pricing.outOfProvince.solo.grossRate)), ((_pricing$outOfProvinc = pricing.outOfProvince.solo.pastRates) === null || _pricing$outOfProvinc === void 0 ? void 0 : _pricing$outOfProvinc.grossRate) > 0 && /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    },
    color: Theme.colors.mediumGrey
  }, _numberWithCommas(pricing.outOfProvince.solo.pastRates.grossRate))), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, pricing.outOfProvince.carrier || 'N/A')), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.rowCondensed
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1
    }
  }, "\xA0\xA0\xA0\xA0", _i18n["default"].t(_tokens["default"].labels.advisor.duo)), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.amountBlock
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _numberWithCommas(pricing.outOfProvince.duo.grossRate)), ((_pricing$outOfProvinc2 = pricing.outOfProvince.duo.pastRates) === null || _pricing$outOfProvinc2 === void 0 ? void 0 : _pricing$outOfProvinc2.grossRate) > 0 && /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    },
    color: Theme.colors.mediumGrey
  }, _numberWithCommas(pricing.outOfProvince.duo.pastRates.grossRate))), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, pricing.outOfProvince.carrier || 'N/A')), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.rowCondensed
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1
    }
  }, "\xA0\xA0\xA0\xA0", _i18n["default"].t(_tokens["default"].labels.advisor.family)), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.amountBlock
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _numberWithCommas(pricing.outOfProvince.family.grossRate)), ((_pricing$outOfProvinc3 = pricing.outOfProvince.family.pastRates) === null || _pricing$outOfProvinc3 === void 0 ? void 0 : _pricing$outOfProvinc3.grossRate) > 0 && /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    },
    color: Theme.colors.mediumGrey
  }, _numberWithCommas(pricing.outOfProvince.family.pastRates.grossRate))), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, pricing.outOfProvince.carrier || 'N/A'))), pricing.stopLoss.family.grossRate > 0 && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.rowCondensed
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1
    }
  }, "\xA0", _i18n["default"].t(_tokens["default"].titles.stopLoss)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  })), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.rowCondensed
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1
    }
  }, "\xA0\xA0\xA0\xA0", _i18n["default"].t(_tokens["default"].labels.advisor.solo)), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.amountBlock
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _numberWithCommas(pricing.stopLoss.solo.grossRate)), ((_pricing$stopLoss$sol = pricing.stopLoss.solo.pastRates) === null || _pricing$stopLoss$sol === void 0 ? void 0 : _pricing$stopLoss$sol.grossRate) > 0 && /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    },
    color: Theme.colors.mediumGrey
  }, _numberWithCommas(pricing.stopLoss.solo.pastRates.grossRate))), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, pricing.stopLoss.carrier || 'N/A')), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.rowCondensed
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1
    }
  }, "\xA0\xA0\xA0\xA0", _i18n["default"].t(_tokens["default"].labels.advisor.duo)), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.amountBlock
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _numberWithCommas(pricing.stopLoss.duo.grossRate)), ((_pricing$stopLoss$duo = pricing.stopLoss.duo.pastRates) === null || _pricing$stopLoss$duo === void 0 ? void 0 : _pricing$stopLoss$duo.grossRate) > 0 && /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    },
    color: Theme.colors.mediumGrey
  }, _numberWithCommas(pricing.stopLoss.duo.pastRates.grossRate))), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, pricing.stopLoss.carrier || 'N/A')), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.rowCondensed
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1
    }
  }, "\xA0\xA0\xA0\xA0", _i18n["default"].t(_tokens["default"].labels.advisor.family)), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.amountBlock
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _numberWithCommas(pricing.stopLoss.family.grossRate)), ((_pricing$stopLoss$fam = pricing.stopLoss.family.pastRates) === null || _pricing$stopLoss$fam === void 0 ? void 0 : _pricing$stopLoss$fam.grossRate) > 0 && /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    },
    color: Theme.colors.mediumGrey
  }, _numberWithCommas(pricing.stopLoss.family.pastRates.grossRate))), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, pricing.stopLoss.carrier || 'N/A'))), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.rowCondensed
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1
    }
  }, "\xA0", _i18n["default"].t(_tokens["default"].titles.employeeFamilyAssistanceProgram)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  })), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.rowCondensed
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1
    }
  }, "\xA0\xA0\xA0\xA0", _i18n["default"].t(_tokens["default"].labels.advisor.solo)), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.amountBlock
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _numberWithCommas(_getEfapGrossRate(pricing, 'solo'))), _getEfapPastRate(pricing, 'solo') > 0 && /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    },
    color: Theme.colors.mediumGrey
  }, _numberWithCommas(_getEfapPastRate(pricing, 'solo')))), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, pricing.employeeAssistance.carrier || 'N/A')), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.rowCondensed
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1
    }
  }, "\xA0\xA0\xA0\xA0", _i18n["default"].t(_tokens["default"].labels.advisor.duo)), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.amountBlock
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _numberWithCommas(_getEfapGrossRate(pricing, 'duo'))), _getEfapPastRate(pricing, 'duo') > 0 && /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    },
    color: Theme.colors.mediumGrey
  }, _numberWithCommas(_getEfapPastRate(pricing, 'duo')))), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, pricing.employeeAssistance.carrier || 'N/A')), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.rowCondensed
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1
    }
  }, "\xA0\xA0\xA0\xA0", _i18n["default"].t(_tokens["default"].labels.advisor.family)), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.amountBlock
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _numberWithCommas(_getEfapGrossRate(pricing, 'family'))), _getEfapPastRate(pricing, 'family') > 0 && /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    },
    color: Theme.colors.mediumGrey
  }, _numberWithCommas(_getEfapPastRate(pricing, 'family')))), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, pricing.employeeAssistance.carrier || 'N/A')), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.rowCondensed
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1
    }
  }, "\xA0", _i18n["default"].t(_tokens["default"].titles.dental)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  })), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.rowCondensed
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1
    }
  }, "\xA0\xA0\xA0\xA0", _i18n["default"].t(_tokens["default"].labels.advisor.solo)), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.amountBlock
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  },
  // Show net rate for ASO since we don't charge the gross rate for ASO
  isAsoDental ? _numberWithCommas(_getDentalNetRate(pricing, 'solo')) : _numberWithCommas(_getDentalGrossRate(pricing, 'solo'))), _getDentalPastRate(pricing, 'solo') > 0 && /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    },
    color: Theme.colors.mediumGrey
  }, _numberWithCommas(_getDentalPastRate(pricing, 'solo')))), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, pricing.basicDental.carrier || 'N/A')), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.rowCondensed
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1
    }
  }, "\xA0\xA0\xA0\xA0", _i18n["default"].t(_tokens["default"].labels.advisor.duo)), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.amountBlock
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  },
  // Show net rate for ASO since we don't charge the gross rate for ASO
  isAsoDental ? _numberWithCommas(_getDentalNetRate(pricing, 'duo')) : _numberWithCommas(_getDentalGrossRate(pricing, 'duo'))), _getDentalPastRate(pricing, 'duo') > 0 && /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    },
    color: Theme.colors.mediumGrey
  }, _numberWithCommas(_getDentalPastRate(pricing, 'duo')))), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, pricing.basicDental.carrier || 'N/A')), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.rowCondensed
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1
    }
  }, "\xA0\xA0\xA0\xA0", _i18n["default"].t(_tokens["default"].labels.advisor.family)), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.amountBlock
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  },
  // Show net rate for ASO since we don't charge the gross rate for ASO
  isAsoDental ? _numberWithCommas(_getDentalNetRate(pricing, 'family')) : _numberWithCommas(_getDentalGrossRate(pricing, 'family'))), _getDentalPastRate(pricing, 'family') > 0 && /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    },
    color: Theme.colors.mediumGrey
  }, _numberWithCommas(_getDentalPastRate(pricing, 'family')))), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, pricing.basicDental.carrier || 'N/A')), pricing.virtualHealthcare && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.rowCondensed
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1
    }
  }, "\xA0", _i18n["default"].t(_tokens["default"].titles.virtualHealthCare)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  })), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.rowCondensed
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1
    }
  }, "\xA0\xA0\xA0\xA0", _i18n["default"].t(_tokens["default"].labels.advisor.solo)), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.amountBlock
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _numberWithCommas(pricing.virtualHealthcare.solo.grossRate)), ((_pricing$virtualHealt = pricing.virtualHealthcare.solo.pastRates) === null || _pricing$virtualHealt === void 0 ? void 0 : _pricing$virtualHealt.grossRate) > 0 && /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    },
    color: Theme.colors.mediumGrey
  }, _numberWithCommas(pricing.virtualHealthcare.solo.pastRates.grossRate))), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, pricing.virtualHealthcare.carrier || 'N/A')), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.rowCondensed
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1
    }
  }, "\xA0\xA0\xA0\xA0", _i18n["default"].t(_tokens["default"].labels.advisor.duo)), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.amountBlock
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _numberWithCommas(pricing.virtualHealthcare.duo.grossRate)), ((_pricing$virtualHealt2 = pricing.virtualHealthcare.duo.pastRates) === null || _pricing$virtualHealt2 === void 0 ? void 0 : _pricing$virtualHealt2.grossRate) > 0 && /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    },
    color: Theme.colors.mediumGrey
  }, _numberWithCommas(pricing.virtualHealthcare.duo.pastRates.grossRate))), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, pricing.virtualHealthcare.carrier || 'N/A')), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.rowCondensed
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1
    }
  }, "\xA0\xA0\xA0\xA0", _i18n["default"].t(_tokens["default"].labels.advisor.family)), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.amountBlock
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _numberWithCommas(pricing.virtualHealthcare.family.grossRate)), ((_pricing$virtualHealt3 = pricing.virtualHealthcare.family.pastRates) === null || _pricing$virtualHealt3 === void 0 ? void 0 : _pricing$virtualHealt3.grossRate) > 0 && /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    },
    color: Theme.colors.mediumGrey
  }, _numberWithCommas(pricing.virtualHealthcare.family.pastRates.grossRate))), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, pricing.virtualHealthcare.carrier || 'N/A'))), pricing.financialAwareness && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.rowCondensed
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1
    }
  }, "\xA0", _i18n["default"].t(_tokens["default"].titles.financialAwareness)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  })), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.rowCondensed
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1
    }
  }, "\xA0\xA0\xA0\xA0", _i18n["default"].t(_tokens["default"].labels.advisor.solo)), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.amountBlock
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _numberWithCommas(pricing.financialAwareness.solo.grossRate)), ((_pricing$financialAwa = pricing.financialAwareness.solo.pastRates) === null || _pricing$financialAwa === void 0 ? void 0 : _pricing$financialAwa.grossRate) > 0 && /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    },
    color: Theme.colors.mediumGrey
  }, _numberWithCommas(pricing.financialAwareness.solo.pastRates.grossRate))), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, pricing.financialAwareness.carrier || 'N/A')), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.rowCondensed
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1
    }
  }, "\xA0\xA0\xA0\xA0", _i18n["default"].t(_tokens["default"].labels.advisor.duo)), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.amountBlock
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _numberWithCommas(pricing.financialAwareness.duo.grossRate)), ((_pricing$financialAwa2 = pricing.financialAwareness.duo.pastRates) === null || _pricing$financialAwa2 === void 0 ? void 0 : _pricing$financialAwa2.grossRate) > 0 && /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    },
    color: Theme.colors.mediumGrey
  }, _numberWithCommas(pricing.financialAwareness.duo.pastRates.grossRate))), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, pricing.financialAwareness.carrier || 'N/A')), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.rowCondensed
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1
    }
  }, "\xA0\xA0\xA0\xA0", _i18n["default"].t(_tokens["default"].labels.advisor.family)), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.amountBlock
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _numberWithCommas(pricing.financialAwareness.family.grossRate)), ((_pricing$financialAwa3 = pricing.financialAwareness.family.pastRates) === null || _pricing$financialAwa3 === void 0 ? void 0 : _pricing$financialAwa3.grossRate) > 0 && /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    },
    color: Theme.colors.mediumGrey
  }, _numberWithCommas(pricing.financialAwareness.family.pastRates.grossRate))), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, pricing.financialAwareness.carrier || 'N/A')))), /*#__PURE__*/_react["default"].createElement("span", {
    id: "pricing-preview"
  }));
};
var _default = exports["default"] = RateTable;